import { Dispatch } from "@reduxjs/toolkit";
import { FieldType } from "../helpers/types";
import { changeFieldsPositions } from "../api/fields.api";

export const setFieldsPositions = (
  dispatch: Dispatch,
  newFields: FieldType[]
) => {
  changeFieldsPositions(dispatch, newFields);
};
